const getters = {
    userInfo: state => state.app.user.userInfo,//用户所有信息
    verifyToken: state => state.app.user.verifyToken, //用户登录时的验证码token
    logo: state => state.app.logo ,//当前用户公司logo
    permissions: state => state.app.user.userInfo && state.app.user.userInfo['permissions']?state.app.user.userInfo['permissions']:null,
    lang: state => state.app.lang,

    controlUserInfo: state => state.app.user.controlUserInfo,//用户所有信息
    controlVerifyToken: state => state.app.user.controlVerifyToken, //用户登录时的验证码token
    controlLogo: state => state.app.logo ,//当前用户公司logo
    controlPermissions: state => state.app.user.userInfo && state.app.user.controlUserInfo['permissions']?state.app.user.controlUserInfo['permissions']:null,
    dataAcrossPage: state => state.app.dataAcrossPage,
};
export default getters
